module.exports = __webpack_public_path__ + "img/stephen.605fed4f.png";